import { render, staticRenderFns } from "./WidgetsDashboard.vue?vue&type=template&id=03b7700d&scoped=true"
import script from "./WidgetsDashboard.vue?vue&type=script&lang=js"
export * from "./WidgetsDashboard.vue?vue&type=script&lang=js"
import style0 from "./WidgetsDashboard.vue?vue&type=style&index=0&id=03b7700d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b7700d",
  null
  
)

export default component.exports